module.exports = __webpack_public_path__ + "static/media/GWDLogo_Icon.fbd83108.png";